import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { initialState } from "./initialState";

const onboardingSlice = createSlice({
  name: "onboarding",
  initialState,
  reducers: {
    toggleOnboarding: (state, action: PayloadAction<boolean>) => {
      state.isActive = action.payload;
    },
  },
});

export const { toggleOnboarding } = onboardingSlice.actions;

export default onboardingSlice.reducer;
